import React, { PropTypes } from 'react';

import Hero from '../../presentational/Hero';

function HeroContainer(props) {
  return (
    <Hero className="left" fluid link="media-links">
      <h1>The latest from <br/><em>Omniderm</em></h1>
      <p>in the Media</p>
    </Hero>
  )
}

export default HeroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/social-media/HeroContainer.jsx
 **/